<template>
  <w-modal
    v-model="isOpen"
    size="large"
    class="form-template-selection-modal"
    title="Selecionar modelo Anamnese e Evolução"
    :close-on-click-outside="false"
    style="z-index: 999999999"
    @close="onClose"
  >
    <template #body>
      <div class="form-template-body">
        <!-- Left: Radio list or skeleton -->
        <div class="template-list">
          <template v-if="templates.length > 0">
            <!-- Templates Padronizados (id < 0) -->
            <div v-if="standardTemplates.length > 0" class="template-group">
              <div class="template-group-title spacing-bottom">Criados pelo Noa</div>
              <label
                v-for="template in displayedStandardTemplates"
                :key="template.id"
                class="template-radio-item"
                :class="{ selected: selectedId === template.id }"
              >
                <input type="radio"
                  :value="template.id" v-model="selectedId"
                  class="template-radio-input" />
                <span class="template-radio-label">
                  {{ template.description }}
                  <span v-if="!PINNED_STANDARD_IDS.includes(template.id)" class="template-badge-new">Novo</span>
                </span>
              </label>
              <button
                v-if="hasMoreStandard"
                class="see-more-btn"
                @click="standardExpanded = true"
              >
                Ver mais
              </button>
              <button
                v-if="standardExpanded && standardTemplates.length > MAX_INITIAL_STANDARD"
                class="see-more-btn"
                @click="standardExpanded = false"
              >
                Ver menos
              </button>
            </div>

            <!-- Meus Modelos (id >= 0) -->
            <div v-if="customTemplates.length > 0" class="template-group">
              <div class="template-group-title">Criados por você</div>
              <div class="template-group-subtitle spacing-bottom">criados por você em seu estilo de documentação</div>
              <label
                v-for="template in customTemplates"
                :key="template.id"
                class="template-radio-item"
                :class="{ selected: selectedId === template.id }"
              >
                <input type="radio"
                  :value="template.id" v-model="selectedId"
                  class="template-radio-input" />
                <span class="template-radio-label">{{ template.description }}</span>
              </label>
              <button
                v-if="hasMore"
                class="see-more-btn"
                @click="expanded = true"
              >
                Ver mais
              </button>
              <button
                v-if="expanded && allCustomTemplates.length > MAX_INITIAL_CUSTOM"
                class="see-more-btn"
                @click="expanded = false"
              >
                Ver menos
              </button>
            </div>
          </template>
          <template v-else>
            <div v-for="n in 3" :key="n" class="template-radio-item skeleton-item">
              <w-skeleton :height="18" :width="18" shape="circle" />
              <w-skeleton :height="14" shape="pill" width="70%" />
            </div>
          </template>
        </div>

        <!-- Right: Preview -->
        <div class="template-preview">
          <div class="preview-header">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              width="16"
              height="16"
              class="preview-eye-icon"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
            <span class="preview-title">Pré-visualização</span>
          </div>

          <div v-if="selectedTemplateSections.length > 0" class="preview-sections">
            <div v-for="(section, index) in selectedTemplateSections" :key="index" class="preview-section">
              <div class="preview-section-title">{{ section.title }}</div>
              <div class="preview-section-skeleton">
                <w-skeleton :height="10" shape="pill" width="80%" />
                <w-skeleton :height="10" shape="pill" width="50%" class="skeleton-spacing" />
              </div>
            </div>
          </div>

          <div v-else-if="selectedTemplate" class="preview-sections">
            <div v-for="n in 4" :key="n" class="preview-section">
              <div class="preview-section-skeleton">
                <w-skeleton :height="12" shape="pill" width="40%" />
                <w-skeleton :height="10" shape="pill" width="80%" class="skeleton-spacing" />
                <w-skeleton :height="10" shape="pill" width="50%" class="skeleton-spacing" />
              </div>
            </div>
          </div>

          <div v-else class="preview-empty">
            <w-text type="body" text-align="center" class="preview-empty-text">
              Selecione um template para visualizar
            </w-text>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="form-template-footer">
        <w-button label="Cancelar" variant="secondary" @click="onClose" />
        <w-button label="Selecionar modelo"
variant="primary" :disabled="!selectedId"
@click="onConfirm" />
      </div>
    </template>
  </w-modal>
</template>

<style scoped lang="scss">
@import "style-variables.scss";

.form-template-body {
  display: flex;
  gap: 24px;
  padding: var(--w-space-m);
  min-height: 350px;
}

.template-list {
  flex: 0 0 40%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 400px;
}

.see-more-btn {
  display: block;
  margin: 12px auto 0;
  padding: 6px 16px;
  background: none;
  border: none;
  color: var(--w-color-primary, #03c3a5);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}

.template-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.template-group + .template-group {
  margin-top: 16px;
}

.template-group-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--w-text-color, #333);
  letter-spacing: 0.5px;
}

.template-group-subtitle {
  font-size: 11px;
  color: var(--w-text-color-secondary, #666);
}

.spacing-bottom {
  margin-bottom: 9px;
}

.template-radio-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: var(--w-color-background-hover, #f5f5f5);
  }

  &.selected {
    background: rgba(255, 255, 255, 0.08);
  }

  &.skeleton-item {
    cursor: default;
    pointer-events: none;
  }
}

.template-radio-input {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  cursor: pointer;
  border: 2px solid var(--w-border-color, #d1d5db);
  border-radius: 50%;
  background: #fff;
  transition: all 0.15s ease;

  &:checked {
    border-color: #007c68;
    background: #fff;
    box-shadow: inset 0 0 0 4px #007c68;
  }
}

.template-radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: var(--w-text-color, #333);
}

.template-badge-new {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  background: #e6f7f5;
  color: #007c68;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  flex-shrink: 0;
}

.template-preview {
  flex: 1;
  border: 1px solid var(--w-border-color, #e0e0e0);
  border-radius: 8px;
  padding: 16px;
  background: var(--w-color-background-secondary, #fafafa);
  overflow-y: auto;
  max-height: 400px;
}

.preview-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--w-border-color, #e0e0e0);
}

.preview-eye-icon {
  color: var(--w-text-color-secondary, #666);
  flex-shrink: 0;
}

.preview-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--w-text-color-secondary, #666);
  // text-transform: uppercase;
  letter-spacing: 0.5px;
}

.preview-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.preview-section {
  padding: 12px 0;
}

.preview-section-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--w-text-color, #333);
  margin-bottom: 4px;
}

.preview-section-skeleton {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.skeleton-spacing {
  margin-top: 2px;
}

.preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.preview-empty-text {
  color: var(--w-text-color-secondary, #999);
}

.form-template-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: var(--w-space-sm);
}
</style>

<style>
.form-template-selection-modal .w-skeleton,
.form-template-selection-modal .w-skeleton * {
  animation: none !important;
  background: #e5e7eb !important;
  background-image: none !important;
}
</style>

<script setup lang="ts">
import { ref, computed, watch } from "vue";

interface Template {
  id: number;
  description: string;
  name?: string;
  sections?: Record<string, string>;
}

const MAX_INITIAL_CUSTOM = 3;
const MAX_INITIAL_STANDARD = 3;

interface Props {
  templates: Template[];
  preSelectedTemplateId: number | null;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: "select", templateId: number): void;
  (e: "close"): void;
}>();

const isOpen = ref(true);
const expanded = ref(false);
const standardExpanded = ref(false);
const confirming = ref(false);

const PINNED_STANDARD_IDS = [-4, -5];

const selectedId = ref<number | null>(props.preSelectedTemplateId ?? props.templates[0]?.id ?? null);

/** Templates padronizados (id < 0) */
const standardTemplates = computed(() => props.templates.filter((t) => t.id < 0));

/** Templates padronizados visíveis por padrão (primeiros 3) */
const displayedStandardTemplates = computed(() => {
  if (standardExpanded.value) return standardTemplates.value;
  return standardTemplates.value.slice(0, MAX_INITIAL_STANDARD);
});

/** Mostra "Ver mais" quando há mais de 3 templates padronizados */
const hasMoreStandard = computed(
  () => standardTemplates.value.length > MAX_INITIAL_STANDARD && !standardExpanded.value,
);

/** All custom templates (id >= 0) */
const allCustomTemplates = computed(() => props.templates.filter((t) => t.id >= 0));

/** Custom templates shown (first 5 or all if expanded) */
const customTemplates = computed(() => {
  if (expanded.value) return allCustomTemplates.value;
  return allCustomTemplates.value.slice(0, MAX_INITIAL_CUSTOM);
});

/** Show "Ver mais" when there are more than 5 custom templates */
const hasMore = computed(() => allCustomTemplates.value.length > MAX_INITIAL_CUSTOM && !expanded.value);

const selectedTemplate = computed(() => {
  if (!selectedId.value) return null;
  return props.templates.find((t) => t.id === selectedId.value) ?? null;
});

/** Parsed sections from template: { title, description } pairs */
const selectedTemplateSections = computed(() => {
  if (!selectedTemplate.value) return [];
  const sections = selectedTemplate.value.sections;
  if (sections && typeof sections === "object" && !Array.isArray(sections)) {
    return Object.entries(sections).map(([title, description]) => ({ title, description }));
  }
  return [];
});

watch(isOpen, (val) => {
  if (!val && !confirming.value) emit("close");
});

watch(
  () => props.preSelectedTemplateId,
  (newId) => {
    if (newId !== null) selectedId.value = newId;
  },
);

const onConfirm = () => {
  if (selectedId.value) {
    confirming.value = true;
    emit("select", selectedId.value);
  }
};

const onClose = () => {
  isOpen.value = false;
};
</script>
